import { useTranslation } from "react-i18next";
import { useRouteNode } from "react-router5";
function ThemesTrending({ setPostTrending, themes, root }) {
  const { t } = useTranslation();

  let view;
  let container;
  // sort by total trending desc
  const data = themes.slice().sort((a, b) => b.total_counts - a.total_counts);

  if (root === "explore") {
    view = <p>{t("Thèmes")}</p>;
  } else {
    view = <p>{t("Thèmes en tendances")}</p>;
  }

  if (data.length !== 0) {
    container = (
      <div
        className={`c-themes_themeList${root === "explore" ? "_explore" : ""}`}
      >
        {data.map((c) => {
          return (
            <Themes
              themes={c}
              key={c.id}
              id={c.id}
              root={root}
              setPostTrending={setPostTrending}
            />
          );
        })}
      </div>
    );
  } else {
    container = (
      <div
        className={`c-themes_themeList${root === "explore" ? "_explore" : ""}`}
      >
        <p className="c-message_empty">{t("Aucun éléments à afficher")}</p>
      </div>
    );
  }

  return (
    <>
      <div
        className={`c-container_themes${root === "explore" ? "_explore" : ""}`}
      >
        <div className="c-themes_header">{view}</div>
        {container}
      </div>
    </>
  );
}

function Themes({ themes, root, id, setPostTrending }) {
  const { t } = useTranslation();

  const { router } = useRouteNode("explore");

  const { item, confidential, total_counts } = themes;

  let span, onClick;

  const navigateToTheme = (id) => {
    router.navigate("explore.theme", { id: id });
  };

  if (root === "explore") {
    span = <span className="c-contact_countNews">{total_counts}</span>;
    onClick = () => navigateToTheme(themes.id);
  } else {
    span = (
      <span className="c-contact_countNews">
        {total_counts} {t("articles")}
        {total_counts > 1 ? "s" : ""}
      </span>
    );
    onClick = () => setPostTrending(id);
  }

  return (
    <div
      className={`c-themes_card${root === "explore" ? "_explore" : ""}`}
      onClick={onClick}
    >
      <span className="c-order_number">{`#${id}`}</span>
      <div className="c-themes_infos">
        <div className="c-themes_name">
          {item}
          {confidential && <div className="lock-icon-focus" />}
        </div>
        {span}
      </div>
    </div>
  );
}

export default ThemesTrending;
